import { render, staticRenderFns } from "./query1.vue?vue&type=template&id=4119abc6&scoped=true"
import script from "./query1.vue?vue&type=script&lang=js"
export * from "./query1.vue?vue&type=script&lang=js"
import style0 from "./query1.vue?vue&type=style&index=0&id=4119abc6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4119abc6",
  null
  
)

export default component.exports